module.exports = __webpack_public_path__ + "static/sur-mesure.b75a8f01.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Page/img/sur-mesure.png
// module id = 817
// module chunks = 28686525722576